<template >
  <b-container fluid role="tablist" v-if="treeGrant != null" class="bg-collapse">
    <b-row no-gutters>
      <b-col >

        <b-row  class="mb-1" v-for="branch in treeGrant" :key="branch[0]">

          <b-col cols="12" v-if="branch[0]=='Orden de Pago'">
            <b-card-header header-tag="header" class="p-1" role="tab" >
              <b-button id="Orden de Pago" class="btn-cat-sidebar" size="sm" block @click="updateItemSelected"><b-icon variant="light" icon="upc-scan"/> Orden de Pago</b-button>
            </b-card-header>
          </b-col>

          <b-col cols="12" v-if="branch[0]!='Orden de Pago' && branch[0]!='Subsidios' && branch[0]!='Integración IUSA' && branch[0]!='Transacciones TPV' && branch[0]!='Parquímetro Validación' && branch[0]!='Registro Pagos Externos'" >
            <b-card-header header-tag="header" class="p-1" role="tab" >
              <h1 v-show="false">{{id = branch[0].replaceAll(' ', '')}}</h1>
              <b-button class="btn-cat-sidebar"  size="sm" block  v-b-toggle="branch[0].replaceAll(' ', '')"><b-icon  variant="light" :icon="getIconCat(branch[0])"/> {{branch[0]}}</b-button>              
            </b-card-header>
            <b-collapse :id="branch[0].replaceAll(' ', '')"  accordion="my-accordion" role="tabpanel" >
              <div style="margin-left:35px;">
                <b-button size="sm" block class="btn-cat-sidebar" :id="leaf" v-for="leaf in branch[1]" :key="leaf" @click="updateItemSelected"><b-icon variant="light" icon="node-plus-fill"/> {{leaf}}</b-button>
              </div>
            </b-collapse>
          </b-col>     

          <div v-if="branch[0]=='Subsidios'">
            <b-card-header header-tag="header" class="p-1" role="tab" >
              <b-button id="Subsidios" class="btn-cat-sidebar" size="sm" block @click="updateItemSelected"><b-icon variant="light" icon="person-check-fill"/> Subsidios</b-button>
            </b-card-header>
          </div>
          
          <div v-if="branch[0]=='Integración IUSA'">
            <b-card-header header-tag="header" class="p-1" role="tab" >
              <b-button id="Integración IUSA" class="btn-cat-sidebar" size="sm" block @click="updateItemSelected"><b-icon variant="light" icon="person-check-fill"/> Integración IUSA</b-button>
            </b-card-header>
          </div>

          <div v-if="branch[0]=='Transacciones TPV'">
            <b-card-header header-tag="header" class="p-1" role="tab" >
              <b-button id="Transacciones TPV" class="btn-cat-sidebar" size="sm" block @click="updateItemSelected"><b-icon variant="light" icon="card-heading"/> Transacciones TPV</b-button>
            </b-card-header>
          </div>
          
           <div v-if="branch[0]=='Registro Pagos Externos'">
            <b-card-header header-tag="header" class="p-1" role="tab" >
              <b-button id="Registro Pagos Externos" class="btn-cat-sidebar" size="sm" block @click="updateItemSelected"><b-icon variant="light" icon="card-heading"/> Registro Pagos Externos</b-button>
            </b-card-header>
          </div>

          <div v-if="branch[0]=='Parquímetro Validación'">
            <b-card-header header-tag="header" class="p-1" role="tab" >
              <b-button id="Parquímetro Validación" class="btn-cat-sidebar" size="sm" block @click="updateItemSelected"><b-icon variant="light" icon="card-heading"/> Parquímetro Validación</b-button>
            </b-card-header>
          </div>

        </b-row>


      </b-col>
    </b-row>
    
  </b-container>
</template>

<script>
  import { mapState} from 'vuex'
  //import { navTo } from '@/vue-tools'

  export default {
    computed: mapState({
        treeGrant: state => state.cobro.treeGrant,
        isGenerando: state => state.cobro.isGenerando,
        isCalculando: state => state.cobro.isCalculando,
        catalogCobro: state => state.cobro.catalogCobro
    }),
    mounted() {
      
    },
    data() {
      return {
        
      }
    },
    methods: {
      updateItemSelected(event){
        if(!this.isCalculando && !this.isGenerando){
          this.$store.commit("configLiqFormModelFor", event.currentTarget.id);
          this.$store.commit('updateItemSelected', event.currentTarget.id);
          if(event.currentTarget.id=='Subsidios' || event.currentTarget.id=='Integración IUSA' || event.currentTarget.id=='Transacciones TPV'){
            this.$store.commit("clearResultsCobro");
          }          
          this.$store.commit("updateIsLiqFormCollapse", false);
          if(window.matchMedia("(max-width: 768px)").matches){
            this.$store.commit("updateIsShowSideCobro", false);
            
          }
          window.scrollTo(0, 0);
          
        }
      },
      getIconCat(cate){
        var cat = cate.toLowerCase();
        var i =
        cat == "impuesto predial"? 'house-door-fill':
        cat == "adquisición de inmuebles"? 'people-fill':
        cat == "conjuntos urbanos"? 'grid3x3-gap-fill':
        cat == "anuncios publiciatarios"? 'image-fill':
        cat == "juegos y espectáculos"? 'collection-play-fill':
        cat == "agua potable"? 'droplet-fill':
        cat == "registro civil"? 'book-fill':
        cat == "desarrollo urbano"? 'map-fill':
        cat == "servicios administrativos"? 'archive-fill':
        cat == "rastros"? 'trash2-fill':
        cat == "corral de consejo"? 'bucket-fill':
        cat == "uso de vías públicas"? 'cart-check-fill':
        cat == "panteones"? 'plus-square-fill':
        cat == "estacionamientos"? 'cone-striped':
        cat == "bebidas alcohólicas"? 'file-earmark-medical-fill':
        cat == "seguridad pública"? 'shield-fill-check':
        cat == "limpieza y residuos"? 'funnel-fill':
        cat == "catastro"? 'geo-alt-fill':
        cat == "otros ingresos"? 'hdd-stack-fill' : 'bookmark-fill';
        return i;
      },
      
    }
  }
</script>
<style>
.bg-collapse {
      padding:0px;
    }
</style>